





























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as api from '@/api/api';
import * as def from '@/common/definitions';
import GameDateTimePicker from '@/components/parts/GameDateTimePicker.vue';

@Component({
  components: {
    GameDateTimePicker,
  },
})
export default class WarView extends Vue {
  @Prop() private current!: api.GameDateTime;
  @Prop() private lastWar?: api.TownWar;
  @Prop() private status!: def.TownWarStatus;
  @Prop() private town!: api.Town;
  @Prop() private country!: api.Country;
  @Prop() private myCountryId!: number;
  @Prop() private isSending!: boolean;
  @Prop() private canEdit!: boolean;
  @Prop() private isShow!: boolean;
  @Prop() private wars!: api.CountryWar[];
  @Prop() private towns!: api.Town[];
  private isOpen: boolean = false;

  private get canWar(): boolean {
    let result = false;
    if (this.status.id === 0 || this.status.id === 3) {
      result = true;
    }

    if (result) {
      result = this.canWarWithHasCountry &&
        this.canWarWithNotCapital && this.canWarWithNear && this.canWarWithNotSingleTown &&
        this.canWarWithNotTooEarly && this.canWarWithStartBefore6Months && this.canWarWithEachOtherWars;
    }

    return result;
  }

  private get canWarWithOtherCountry(): boolean {
    return this.town.countryId !== this.myCountryId;
  }

  private get canWarWithHasCountry(): boolean {
    return this.town.countryId > 0;
  }

  private get canWarWithNotCapital(): boolean {
    return this.town.id !== this.country.capitalTownId;
  }

  private get canWarWithNear(): boolean {
    // return api.TownBase.getAroundTowns(this.towns, this.town).some((t) => t.countryId === this.myCountryId);
    return true;
  }

  private get canWarWithNotSingleTown(): boolean {
    return this.towns.filter((t) => t.countryId).length > 1;
  }

  private get canWarWithNotTooEarly(): boolean {
    if (this.status.id === 3) {
      if (this.lastWar) {
        return api.GameDateTime.toNumber(this.current) - api.GameDateTime.toNumber(this.lastWar.gameDate) >= 120;
      }
    }
    return true;
  }

  private get canWarWithStartBefore6Months(): boolean {
    const war = this.wars.find((w) => api.CountryDipromacy.isEqualCountry(w, this.country.id, this.myCountryId));
    if (war) {
      if (api.GameDateTime.toNumber(this.current) > api.GameDateTime.toNumber(war.startGameDate) - 6) {
        return false;
      }
    }
    return true;
  }

  private get canWarWithEachOtherWars(): boolean {
    const war = this.wars.find((w) => api.CountryDipromacy.isEqualCountry(w, this.country.id, this.myCountryId));
    if (!war) {
      const otherWar = this.wars.find((w) => w.insistedCountryId === this.country.id ||
                                             w.requestedCountryId === this.country.id);
      if (otherWar && (otherWar.status === api.CountryWar.statusInReady ||
                       otherWar.status === api.CountryWar.statusAvailable ||
                       otherWar.status === api.CountryWar.statusStopRequesting)) {
        return false;
      }
    }
    return true;
  }

  private get nextMonth(): api.GameDateTime {
    return api.GameDateTime.nextMonth(this.current);
  }

  @Watch('isShow')
  private onIsShowChanged() {
    if (this.isShow) {
      this.isOpen = false;
      this.$emit('can-apply', this.isOpen);
    }
  }

  @Watch('isOpen')
  private onIsOpenChanged() {
    this.$emit('can-apply', this.isOpen);
  }

  private created() {
    this.onIsShowChanged();
    this.onIsOpenChanged();
  }
}
